import React, { InputHTMLAttributes, useState } from 'react';

import './ColorPicker.scss';
import { InputText } from 'primereact/inputtext';
import { formatHexColor } from 'utils/utils';

const ColorPicker: React.FC<InputHTMLAttributes<HTMLInputElement>> = props => {
	const [colorText, setColorText] = useState(props.value);

	const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		const regex = /^#[0-9a-fA-F]*$/;
		let { value } = e.target;
		if (value.length > 0) value = formatHexColor(value);
		if ((!regex.test(value) && value.length > 0) || value.length > 7) return;
		setColorText(value);
	};

	return (
		<div className='p-inputgroup flex  w-8rem'>
			<InputText
				value={colorText}
				onChange={handleChange}
				className='p-inputtext-sm p-2'
				onFocus={e => e.target.select()}
			/>
			<input
				type='color'
				{...props}
				value={(colorText as string).length === 7 ? colorText : '#000000'}
				onChange={handleChange}
				className="color-picker p-inputgroup-addon"
			/>
		</div>
	);
};

export default ColorPicker;
